module.exports = __webpack_public_path__ + "img/ic_food_function_canteen_tabes_img1.a22fc50b.png";